/* eslint-disable @typescript-eslint/no-empty-function */

import { Directive, inject, Injector, OnInit } from '@angular/core';
import {
  ControlValueAccessor,
  FormControl,
  FormControlDirective,
  FormControlName,
  FormGroupDirective,
  NG_VALUE_ACCESSOR,
  NgControl,
} from '@angular/forms';

@Directive({
  standalone: true,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: ControlValueAccessorDirective,
      multi: true,
    },
  ],
})
export class ControlValueAccessorDirective<T>
  implements ControlValueAccessor, OnInit
{
  public control!: FormControl;
  private readonly _injector = inject(Injector);

  ngOnInit(): void {
    this._setFormControl();
  }

  private _setFormControl(): void {
    const ngControl = this._injector.get(NgControl, null, {
      self: true,
      optional: true,
    });

    if (!ngControl) {
      this.control = new FormControl<T | null>(null);
      return;
    }

    if (ngControl instanceof FormControlName) {
      const parent: FormGroupDirective = this._injector.get(FormGroupDirective);
      this.control = parent?.getControl(ngControl) as FormControl<T | null>;
      return;
    }

    if (ngControl instanceof FormControlDirective) {
      this.control = ngControl.form as FormControl<T | null>;
    }
  }

  public writeValue(): void {}
  public registerOnChange(): void {}
  public registerOnTouched(): void {}
}
